module.exports = __webpack_public_path__ + "static/media/colabs_rocketship_white.1afee1ab.svg";